"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chartColors_1 = __importDefault(require("../chartColors"));
var shadows_1 = __importDefault(require("../shadows"));
var colors_1 = __importDefault(require("./colors"));
var sidebarColors_1 = __importDefault(require("./sidebarColors"));
var variables_1 = __importDefault(require("./variables"));
var theme = {
    colors: colors_1.default,
    chartColors: chartColors_1.default,
    shadows: shadows_1.default,
    sidebarColors: sidebarColors_1.default,
    variables: variables_1.default
};
exports.default = theme;
//# sourceMappingURL=index.js.map